



















import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant';
@Component({
    components: {},
})
export default class headPanel extends Vue {
   
    public $refs!: {
       
    };

    @Prop({
        default:''
    })
    title:String;

    async mounted() {
        
    }
    async created() {
    
    }

    goback(){
        this.$emit('goback')
    }

    

   
   


}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/headPanel.vue